import { create } from 'apisauce';

export const apiDecidir = (apiKeyDecidir, urlBase) =>
  create({
    baseURL: urlBase,
    headers: { apikey: apiKeyDecidir },
    timeout: 15000
  });
